import { Injectable } from '@angular/core';

import { HttpService, NotificationService, TmsWebBaseEditCreateService } from 'tms-lib';
import { ConnectionType } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ConnectionTypeService extends TmsWebBaseEditCreateService<ConnectionType, ConnectionType> {
  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('ConnectionType', $localize`Connection Type`, httpService, notificationService);
  }
}
